import React from "react";
import { CCard, CCardBody } from "@coreui/react";
import AdminShell from "./AdminShell";

export default function AdminPageFrame({
  title,
  subtitle,
  actions = null,
  badge = "Experts4Europe Admin",
  contentClassName = "",
  shellProps = {},
  children,
}) {
  return (
    <AdminShell title={title} subtitle={subtitle} badge={badge} actions={actions} {...shellProps}>
      <CCard className="admin-page-frame">
        <CCardBody className={`admin-page-frame__body ${contentClassName}`.trim()}>
          {children}
        </CCardBody>
      </CCard>
    </AdminShell>
  );
}
